import React from 'react';

import CustomTable from '../../../components/CustomTable';

import './styles.css';

export default function ResultList(props) {
    return (
        <CustomTable
            className={'table-reporte-venta-producto'}
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPdfRegistrado={props.loadingPdfRegistrado}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onExportPdfRegistrado={props.onExportPdfRegistrado}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.uid}
            columns={[

                {
                    title: 'Datos de Producto',
                    className: 'parent-group show',
                    children: [
                        {
                            title: 'Código Referencia',
                            dataIndex: 'codigoReferencia',
                            key: 'codigoReferencia',
                            className: 'parent-group show',
                            sorter: true
                        },
                        {
                            title: 'Producto',
                            dataIndex: 'nombre',
                            key: 'nombre',
                            className: 'parent-group show',
                            sorter: true,
                            render: (value) => (
                                <div style={{ minWidth: "200px" }}>{value}</div>
                            )
                        },

                        {
                            title: 'Código Barra',
                            dataIndex: 'marca',
                            key: 'marca',
                            className: 'parent-group show',
                            sorter: true
                        },
                        {
                            title: 'Serie',
                            dataIndex: 'serie',
                            key: 'serie',
                            className: 'parent-group show',
                            sorter: true
                        },

                    ]
                },


                {
                    title: 'Datos de Ingreso',
                    className: 'parent-group show',
                    children: [
                        {
                            title: 'Nro Documento',
                            dataIndex: 'nroProveedor',
                            key: 'nroProveedor',
                            className: 'parent-group show',
                            sorter: true
                        },
                        {
                            title: 'Razón Social',
                            dataIndex: 'nombreProveedor',
                            key: 'nombreProveedor',
                            className: 'parent-group show',
                            sorter: true,
                            render: (value) => (
                                <div style={{ minWidth: "200px" }}>{value}</div>
                            )
                        },
                        {
                            title: 'Concepto',
                            dataIndex: 'conceptoIngreso',
                            key: 'conceptoIngreso',
                            className: 'parent-group show',
                            sorter: true
                        },
                        {
                            title: 'Documento Relacionado',
                            dataIndex: 'relacionadoIngreso',
                            key: 'relacionadoIngreso',
                            className: 'parent-group show',
                            sorter: true
                        },

                        {
                            title: 'Fecha',
                            dataIndex: 'fechaIngresoStr',
                            key: 'fechaIngresoStr',
                            className: 'parent-group show',
                            sorter: true
                        },
                        {
                            title: 'Establecimiento',
                            dataIndex: 'estaIngreso',
                            key: 'estaIngreso',
                            align: 'right',
                            className: 'parent-group show',
                            sorter: true
                        },
                        {
                            title: 'Almácen',
                            dataIndex: 'almacenIngreso',
                            key: 'almacenIngreso',
                            align: 'right',
                            className: 'parent-group show',
                            sorter: true
                        },


                    ]
                },



                {
                    title: 'Datos Salidas',
                    className: 'parent-group show',
                    children: [
                        {
                            title: 'Nro Documento',
                            dataIndex: 'nroCliente',
                            key: 'nroCliente',
                            className: 'parent-group show',
                            sorter: true
                        },
                        {
                            title: 'Razón Social',
                            dataIndex: 'nombreCliente',
                            key: 'nombreCliente',
                            className: 'parent-group show',
                            sorter: true,
                            render: (value) => (
                                <div style={{ minWidth: "200px" }}>{value}</div>
                            )
                        },
                        {
                            title: 'Concepto',
                            dataIndex: 'conceptoSalida',
                            key: 'conceptoSalida',
                            className: 'parent-group show',
                            sorter: true
                        },
                        {
                            title: 'Documento Relacionado',
                            dataIndex: 'relacionadoSalida',
                            key: 'relacionadoSalida',
                            className: 'parent-group show',
                            sorter: true
                        },

                        {
                            title: 'Fecha',
                            dataIndex: 'fechaSalidaStr',
                            key: 'fechaSalidaStr',
                            className: 'parent-group show',
                            sorter: true
                        },
                        {
                            title: 'Establecimiento',
                            dataIndex: 'estaSalida',
                            key: 'estaSalida',
                            align: 'right',
                            className: 'parent-group show',
                            sorter: true
                        },
                        {
                            title: 'Almácen',
                            dataIndex: 'almacenSalida',
                            key: 'almacenSalida',
                            align: 'right',
                            className: 'parent-group show',
                            sorter: true
                        },
                    ]
                }
            ]}
        />
    );
}